import React from 'react'
import {observer} from 'mobx-react-lite'

type AgGridCellComponent<PropsType, RefType> = (
    props: React.PropsWithoutRef<PropsType>,
    ref: React.Ref<RefType>
) => JSX.Element | null

type WrappedAgGridCellComponent<PropsType, RefType> = React.ForwardRefExoticComponent<
    React.PropsWithoutRef<PropsType> & React.RefAttributes<RefType>
>

/**
 * Use this HOC to wrap AG Grid cell component so that "ref" is passed correctly.
 * The returned HOC will be MobX.observer.
 *
 * This function is only needed if cell component uses "ref".
 */
export function wrapAgGridCellComponentObservable<PropsType, RefType = unknown>(
    Component: AgGridCellComponent<PropsType, RefType>
): WrappedAgGridCellComponent<PropsType, RefType> {
    return observer(React.forwardRef(Component))
}
